import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Modal, Button, Stack, TextField, Checkbox, Typography, FormControl, Autocomplete } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBR from 'date-fns/locale/pt-BR';

import { updateGenericData, getUsuarios, getGenericData } from '../../api';

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const AddAgenda = React.forwardRef((props, ref) => {
  const [novaAgenda, setNovaAgenda] = useState({
    usuario: JSON.parse(localStorage.getItem('userData')),
    dataAgenda: new Date(),
    descricao: '',
  });
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));

  const [options, setOptions] = useState([]);
  useEffect(() => {
    const fetchUsuarios = async () => {
      const result = await getUsuarios();
      setOptions(result);
    };
    fetchUsuarios();
  }, []);
  const [motivos, setMotivos] = useState([]);
  useEffect(() => {
    const getMotivos = async () => {
      const result = await getGenericData('motivoagenda', {});
      setMotivos(result);
    };
    getMotivos();
  }, []);

  const handleAutoCompleteChange = (idName, name, value) => {
    setNovaAgenda({
      ...novaAgenda,
      [idName]: value?._id,
      [name]: value,
    });
  };

  // salvar nova agenda
  const handleAddAgenda = async () => {
    const nova = {
      ...novaAgenda,
      dataAgenda: novaAgenda.dataAgenda.toISOString(),
      idProposta: props.proposta._id,
    };
    await updateGenericData('agenda', nova);
    setNovaAgenda({ usuario: '', dataAgenda: new Date(), descricao: '', pid: null });
    props.onConfirmAgenda(nova);
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          minWidth: 400,
        }}
      >
        <Typography variant="subtitle1" sx={{ mt: 10 }}>
          Nova agenda
        </Typography>

        <FormControl fullWidth sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <DatePicker
              label="Data da agenda"
              value={novaAgenda.dataAgenda}
              onChange={(newValue) => {
                setNovaAgenda((prev) => ({
                  ...prev,
                  dataAgenda: newValue,
                }));
              }}
              renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 2 }} />}
            />
          </LocalizationProvider>
          <Autocomplete
            disablePortal
            id="idUsuario"
            name="idUsuario"
            value={novaAgenda.usuario || null}
            onChange={(_, value) => handleAutoCompleteChange('idUsuario', 'usuario', value)}
            options={options}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option) => `${option.nome}`}
            renderInput={(params) => <TextField {...params} placeholder="Usuario" />}
            sx={{ mt: 2 }}
            disabled={!usuarioLogado.supervisor}
          />
          <Autocomplete
            disablePortal
            id="motivoAgenda"
            name="motivoAgenda"
            value={novaAgenda?.motivoAgenda || null}
            onChange={(_, value) => handleAutoCompleteChange('idMotivoAgenda', 'motivoAgenda', value)}
            options={motivos}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option) => `${option.nome}`}
            renderInput={(params) => <TextField {...params} placeholder="Motivo Agenda" />}
            sx={{ mt: 2 }}
          />
        </FormControl>

        <TextField
          fullWidth
          label="Descrição"
          value={novaAgenda.descricaoAgenda}
          onChange={(e) => setNovaAgenda({ ...novaAgenda, descricaoAgenda: e.target.value })}
          multiline
          rows={3}
          sx={{ mt: 2 }}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button variant="contained" onClick={handleAddAgenda}>
            Salvar
          </Button>
          <Button variant="outlined" onClick={props.onClose}>
            Cancelar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

AddAgenda.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default AddAgenda;
